import { hideLoading, showLoading } from 'react-redux-loading-bar';
import toast from 'react-hot-toast';
import api from '../../utils/api';

const ActionType = {
  RECEIVE_DETAIL_THREAD: 'detailThread/receive',
  CLEAR_DETAIL_THREAD: 'detailThread/clear',
  UPVOTE_DETAIL_THREAD: 'detailThread/upvoteThread',
  DOWNVOTE_DETAIL_THREAD: 'detailThread/downvoteThread',
  NEUTRALIZE_DETAIL_THREAD_VOTE: 'detailThread/neutralizeThreadVote',
  ADD_COMMENT: 'detailThread/addComment',
  UPVOTE_COMMENT: 'detailThread/upvoteComment',
  DOWNVOTE_COMMENT: 'detailThread/downvoteComment',
  NEUTRALIZE_COMMENT_VOTE: 'detailThread/neutralizeCommentVote',
};

const receiveDetailThreadActionCreator = (detailThread) => ({
  type: ActionType.RECEIVE_DETAIL_THREAD,
  payload: {
    detailThread,
  },
});

const clearDetailThreadActionCreator = () => ({
  type: ActionType.CLEAR_DETAIL_THREAD,
});

const addCommentActionCreator = (comment) => ({
  type: ActionType.ADD_COMMENT,
  payload: {
    comment,
  },
});

const upvoteCommentActionCreator = ({ commentId, userId }) => ({
  type: ActionType.UPVOTE_COMMENT,
  payload: {
    commentId,
    userId,
  },
});

const downvoteCommentActionCreator = ({ commentId, userId }) => ({
  type: ActionType.DOWNVOTE_COMMENT,
  payload: {
    commentId,
    userId,
  },
});

const neutralizeCommentVoteActionCreator = ({ commentId, userId }) => ({
  type: ActionType.NEUTRALIZE_COMMENT_VOTE,
  payload: {
    commentId,
    userId,
  },
});

const upvoteDetailThreadActionCreator = (userId) => ({
  type: ActionType.UPVOTE_DETAIL_THREAD,
  payload: {
    userId,
  },
});

const downvoteDetailThreadActionCreator = (userId) => ({
  type: ActionType.DOWNVOTE_DETAIL_THREAD,
  payload: {
    userId,
  },
});

const neutralizeDetailThreadVoteActionCreator = (userId) => ({
  type: ActionType.NEUTRALIZE_DETAIL_THREAD_VOTE,
  payload: {
    userId,
  },
});

const asyncReceiveDetailThread = (threadId) => async (dispatch) => {
  dispatch(showLoading());
  dispatch(clearDetailThreadActionCreator());
  try {
    const detailThread = await api.getDetailThread(threadId);
    dispatch(receiveDetailThreadActionCreator(detailThread));
  } catch (error) {
    toast.error(error.message);
  }
  dispatch(hideLoading());
};

const asyncAddComment = ({ content, threadId }) => async (dispatch) => {
  dispatch(showLoading());
  try {
    const comment = await api.createComment({ content, threadId });
    dispatch(addCommentActionCreator(comment));
    toast.success('Your comment was successfully sent!');
  } catch (error) {
    toast.error(error.message);
  }
  dispatch(hideLoading());
};

const asyncUpvoteComment = (commentId) => async (dispatch, getState) => {
  dispatch(showLoading);
  const { authUser, detailThread } = getState();
  dispatch(upvoteCommentActionCreator({ userId: authUser.id, commentId }));
  try {
    await api.upvoteComment({ threadId: detailThread.id, commentId });
    toast.success('Comment upvoted!');
  } catch (error) {
    toast.error(error.message);
    dispatch(receiveDetailThreadActionCreator(detailThread));
  }
  dispatch(hideLoading());
};

const asyncDownvoteComment = (commentId) => async (dispatch, getState) => {
  dispatch(showLoading);
  const { authUser, detailThread } = getState();
  dispatch(downvoteCommentActionCreator({ userId: authUser.id, commentId }));
  try {
    await api.downvoteComment({ threadId: detailThread.id, commentId });
    toast.success('Comment downvoted!');
  } catch (error) {
    toast.error(error.message);
    dispatch(receiveDetailThreadActionCreator(detailThread));
  }
  dispatch(hideLoading());
};

const asyncNeutralizeCommentVote = (commentId) => async (dispatch, getState) => {
  dispatch(showLoading);
  const { authUser, detailThread } = getState();
  dispatch(neutralizeCommentVoteActionCreator({ userId: authUser.id, commentId }));
  try {
    await api.neutralizeCommentVote({ threadId: detailThread.id, commentId });
    toast.success('Comment vote neutralized!');
  } catch (error) {
    toast.error(error.message);
    dispatch(receiveDetailThreadActionCreator(detailThread));
  }
  dispatch(hideLoading());
};

const asyncUpvoteDetailThread = () => async (dispatch, getState) => {
  dispatch(showLoading());
  const { authUser, detailThread } = getState();
  dispatch(upvoteDetailThreadActionCreator(authUser.id));
  try {
    await api.upvoteThread(detailThread.id);
    toast.success('Thread upvoted!');
  } catch (error) {
    toast.error(error.message);
    dispatch(receiveDetailThreadActionCreator(detailThread));
  }
  dispatch(hideLoading());
};

const asyncDownvoteDetailThread = () => async (dispatch, getState) => {
  dispatch(showLoading());
  const { authUser, detailThread } = getState();
  dispatch(downvoteDetailThreadActionCreator(authUser.id));
  try {
    await api.downvoteThread(detailThread.id);
    toast.success('Thread downvoted!');
  } catch (error) {
    toast.error(error.message);
    dispatch(receiveDetailThreadActionCreator(detailThread));
  }
  dispatch(hideLoading());
};

const asyncNeutralizeDetailThreadVote = () => async (dispatch, getState) => {
  dispatch(showLoading());
  const { authUser, detailThread } = getState();
  dispatch(neutralizeDetailThreadVoteActionCreator(authUser.id));
  try {
    await api.neutralizeThreadVote(detailThread.id);
    toast.success('Thread vote neutralized!');
  } catch (error) {
    toast.error(error.message);
    dispatch(receiveDetailThreadActionCreator(detailThread));
  }
  dispatch(hideLoading());
};

export {
  ActionType,
  receiveDetailThreadActionCreator,
  clearDetailThreadActionCreator,
  asyncReceiveDetailThread,
  upvoteDetailThreadActionCreator,
  downvoteDetailThreadActionCreator,
  neutralizeDetailThreadVoteActionCreator,
  asyncUpvoteDetailThread,
  asyncDownvoteDetailThread,
  asyncNeutralizeDetailThreadVote,
  addCommentActionCreator,
  upvoteCommentActionCreator,
  downvoteCommentActionCreator,
  neutralizeCommentVoteActionCreator,
  asyncAddComment,
  asyncUpvoteComment,
  asyncDownvoteComment,
  asyncNeutralizeCommentVote,
};
